export default {
  title: '',
  homeMenu: {
    name: 'My Applications',
    desc: 'Check my application history'
  },
  label: {
    company: 'Company Name',
    project: 'Job Name',
    status: 'Status',
    action: 'Action',
    date: 'Date',
    completedApplication: 'Completed Applications',
    incompleteApplication: 'Incomplete Applications',
    removeOneApplication: 'Do you confirm to revoke the application to {jobTitle}?',
    removeAllApplication: 'Do you confirm to revoke? By clicking yes, all your applications to {companyName} will be removed.'
  },
  btn: {
    revokeThis: 'Revoke this application',
    revokeAll: 'Revoke all my applications',
    needProfile: 'Please finish your profile',
    needPersonalitySurvey: 'Please finish the Value & Strength assessment',
    needProblemSolving: 'Please finish the Problem-Solving assessment',
    needMiniSurvey: 'Please complete job application questions',
    needInviteSurvey: 'Please complete invite questions',
    needToAgreePolicy: 'Continue Finish Apply',
    continueFinishQuestion: 'Continue',
    continueFinishApply: 'Continue',
    yes: 'Yes',
    no: 'No'
  },
  message: {
    revokeSuccess: 'revoke success'
  }
}
